import Header from "@/components/Header";
import { Footer2 } from "@/components/ui/shadcnblocks-com-footer2";
import PageTransition from "@/components/PageTransition";
import { SEO } from "@/components/SEO";

const TradeIn = () => {
  return (
    <PageTransition>
      <SEO
        title="Alice Trade-In | החלפת זהב ישן"
        description="שירות Trade-In של אליס תכשיטים - החליפו את תכשיטי הזהב הישנים שלכם בתכשיטים חדשים. קבלו הערכת שווי והצעת מחיר במקום"
        canonical="https://alice.jewelry/trade-in"
        breadcrumbs={[
          { name: 'דף הבית', url: '/' },
          { name: 'Trade-In', url: '/trade-in' },
        ]}
      />
      <div className="min-h-screen flex flex-col" dir="rtl">
        <Header />
        
        <main className="flex-1">
          <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
              <div className="text-center mb-12 animate-fade-in">
                <div className="gold-divider mb-6" />
                <h1 className="text-4xl md:text-5xl font-serif mb-4">Alice Trade-In</h1>
                <p className="text-2xl text-primary mb-2">הזהב שאינך עושה בו שימוש, שווה כסף!</p>
              </div>

              <div className="space-y-6 text-right animate-fade-in" style={{ animationDelay: '0.1s' }}>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  באליס אנו מאפשרים לך להחליף את תכשיטי הזהב שנשברו, או את תכשיטי הזהב שנמצאים באופן קבוע במגירה או בארון, בתכשיט זהב חדש, נוצץ ועדכני באמצעות מבצע Trade-In.
                </p>

                <div className="bg-primary/5 p-8 rounded-lg">
                  <h2 className="text-2xl font-serif mb-4">אז מה צריך לעשות?</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    פשוט, מגיעים לאחת מחנויות הרשת עם הזהב הישן, אנו נשקול אותו, נבצע מספר בדיקות שווי וניתן לכם אופציה לקבל עליו זיכוי לרכישה בחנות או כסף מזומן!
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-4">הפרמטרים שאנו בודקים בחנות:</h3>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <span className="text-primary font-semibold">1</span>
                      </div>
                      <p className="text-muted-foreground pt-1">שער הזהב העדכני בבורסה</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <span className="text-primary font-semibold">2</span>
                      </div>
                      <p className="text-muted-foreground pt-1">משקל הזהב</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <span className="text-primary font-semibold">3</span>
                      </div>
                      <p className="text-muted-foreground pt-1">סוג קראט</p>
                    </div>
                  </div>
                </div>

                <div className="bg-muted/30 p-6 rounded-lg">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    בעת בדיקות אלו בחנות, יכול נציג המכירות לבקש את אישור הלקוח להסרת אבנים מהתכשיט המוחזר לצורך שקילת נטו זהב.
                  </p>
                </div>

                <div className="text-center pt-8">
                  <p className="text-lg mb-4">כבר שקלתם את הזהב ומעוניינים לקבל הערכת שווי?</p>
                  <p className="text-muted-foreground mb-6">צרו עמנו קשר או התקשרו למוקד שירות הלקוחות:</p>
                  <p className="text-2xl text-primary font-semibold" dir="ltr">079-5575576</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer2 />
      </div>
    </PageTransition>
  );
};

export default TradeIn;
